//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MpAppBar from "../../common/components/navigation/MpAppBar";
import MpNavigationDrawer from "../../common/components/navigation/MpNavigationDrawer";
import MpOverlay from "../../common/components/ui/MpOverlay";

export default {
  name: 'App',
  components: {
    MpAppBar,
    MpNavigationDrawer,
    MpOverlay
  },
  props: {
    logo: Object,
    templateMenus: Object,
    profile: Object,
  },
  data: function () {
    return {
      drawer: null
    }
  },
}
